import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { GlobalContext } from "../contexts/Provider";
import StoreSwitch from "./StoreSwitch";
import StoreOption from "./Store/StoreOption";
import VacationWarning from "./Vacation/VacationWarning";

const StoreSwitcher = () => {
    const {
        state: { store, stores, formType, availableMeetingForm },
        dispatch,
    } = useContext(GlobalContext);

    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);
    const listRef = useRef(null);

    const visibleStores = useMemo(
        () =>
            stores.filter(
                (item) => !(formType === "meeting" && item.id === 3 && !availableMeetingForm)
            ),
        [stores, formType, availableMeetingForm]
    );

    const toggle = () => setOpen((o) => !o);
    const close = () => setOpen(false);

    // Auto-select Bratislava store (for AT version)
    useEffect(() => {
        if (visibleStores.length > 0 && !store) {
            const bratislava = visibleStores.find(s => s.title === 'Bratislava');
            dispatch({ type: "CHANGE_STORE", payload: bratislava || visibleStores[0] });
        }
    }, [visibleStores, store, dispatch]);

    useEffect(() => {
        if (!open) return;
        const onClick = (e) => {
            if (!containerRef.current) return;
            if (!containerRef.current.contains(e.target)) close();
        };
        const onKey = (e) => {
            if (e.key === "Escape") close();
        };
        document.addEventListener("mousedown", onClick);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("mousedown", onClick);
            document.removeEventListener("keydown", onKey);
        };
    }, [open]);

    useEffect(() => {
        if (open) {
            listRef.current?.focus();
        }
    }, [open]);

    const onSelect = (item) => {
        dispatch({ type: "CHANGE_STORE", payload: item });
        close();
    };

    // Hide dropdown for AT version - always hide and use auto-selected store
    return null;

    return (
        <>
            <div ref={containerRef} className={"floating-label picker-field " + (open ? "open" : "")}>
                <button
                    type="button"
                    aria-haspopup="listbox"
                    aria-expanded={open}
                    onClick={toggle}
                    className={
                        "trigger w-full text-left bg-transparent text-white py-3 pr-8 focus:outline-none focus:ring-0 focus:border-neutrals-400"
                    }
                >
                    {store ? <StoreOption {...store} /> : "Wählen Sie ein Geschäft*"}
                </button>

                <label className={"text-neutrals-400 " + (store?.id ? "filled" : "")}>
                    Wählen Sie ein Geschäft*
                </label>

                <div
                    className={
                        `overflow-hidden transition-all duration-300 ease-out ${open ? "opacity-100" : "opacity-0"}`
                    }
                    style={{
                        'maxHeight': open ? '160px' : '0'
                    }}
                >
                    <ul role="listbox" aria-label="Liste der Geschäfte" className="mt-2 bg-black shadow-lg">
                        {visibleStores.map((item) => (
                            <StoreSwitch
                                key={item.id}
                                id={item.id}
                                title={item.title}
                                address={item.address}
                                isActive={store?.id === item.id}
                                onSelect={() => onSelect(item)}
                                {...item}
                            />
                        ))}
                    </ul>
                </div>
            </div>

            <VacationWarning
                vacation_start={store?.vacation_start}
                vacation_end={store?.vacation_end}
                vacation_reason_form={store.vacation_reason_form}
            />
        </>
    );
};

export default StoreSwitcher;
